import React from "react";
import { Link } from "react-router-dom";
import estilo from "./styles/TarjetaUltimos.module.css";

function TarjetaUltimos({ ultimos }) {
  return (
    <div className={estilo.tarjeta_ultimos}>
      <Link to={"/" + ultimos.uid + "/" + ultimos.capitulos[0].numero}>
        <h2>{ultimos.nombre}</h2>
        <img src={ultimos.portada} alt={ultimos.nombre} />
        <h4>Cap: {ultimos.capitulos[0].numero}</h4>
        {/* <p>{ultimos.capitulos[0].capitulo}</p> */}
      </Link>
    </div>
  );
}

export default TarjetaUltimos;
